import { LibxGenresState, LibxLocalRegionsState, LibxState } from './state';
import { Level1Out } from '../apiLibx';
import {
    LIBX_GENRES_SET_GENRE,
    LIBX_GENRES_UNSET_GENRE,
    LIBX_LOCAL_REGIONS_SET_LOCAL_REGION,
    LIBX_LOCAL_REGIONS_UNSET_LOCAL_REGION,
    LibxAction,
    LOCAL_CONTENT_GENRES_FAILURE,
    LOCAL_CONTENT_GENRES_REQUEST,
    LOCAL_CONTENT_GENRES_SUCCESS,
    LOCAL_CONTENT_LOCAL_REGIONS_FAILURE,
    LOCAL_CONTENT_LOCAL_REGIONS_REQUEST,
    LOCAL_CONTENT_LOCAL_REGIONS_SUCCESS
} from './types';

const initialLibxState = {} as LibxState;

export default function libxReducer(libx: LibxState = initialLibxState, action: LibxAction): Partial<LibxState> {
    return {
        localRegions: localContentLocalRegionReducer(libx.localRegions, action),
        genres: localContentGenresReducer(libx.genres, action)
    };
}

const initialGenresState = { localContentGenres: [], standardGenres: [], loading: false };

function localContentGenresReducer(genres: LibxGenresState = initialGenresState, action: LibxAction): LibxGenresState {
    switch (action.type) {
        case LOCAL_CONTENT_GENRES_REQUEST:
            return {
                ...genres,
                localContentGenres: [],
                standardGenres: [],
                loading: true
            };
        case LOCAL_CONTENT_GENRES_SUCCESS: {
            const genresList = action.payload;
            return {
                ...genres,
                ...genresList,
                loading: false
            };
        }
        case LOCAL_CONTENT_GENRES_FAILURE:
            return {
                ...genres,
                localContentGenres: [],
                standardGenres: [],
                loading: false
            };

        case LIBX_GENRES_SET_GENRE: {
            const genre = action.payload;
            return {
                ...genres,
                selectedGenre: genre
            };
        }
        case LIBX_GENRES_UNSET_GENRE:
            return {
                ...genres,
                selectedGenre: null
            };

        default:
            return genres;
    }
}

const initialLocalRegionState = { hits: [] as Level1Out[], loading: false } as LibxLocalRegionsState;

function localContentLocalRegionReducer(
    localRegions: LibxLocalRegionsState = initialLocalRegionState,
    action: LibxAction
): LibxLocalRegionsState {
    switch (action.type) {
        case LOCAL_CONTENT_LOCAL_REGIONS_REQUEST:
            return {
                ...localRegions,
                hits: [],
                loading: true
            };
        case LOCAL_CONTENT_LOCAL_REGIONS_SUCCESS: {
            const level1 = action.payload;
            return {
                ...localRegions,
                hits: level1,
                loading: false
            };
        }
        case LOCAL_CONTENT_LOCAL_REGIONS_FAILURE:
            return {
                ...localRegions,
                hits: [],
                loading: false
            };

        case LIBX_LOCAL_REGIONS_SET_LOCAL_REGION: {
            const selectedLocalRegion = action.payload;
            return {
                ...localRegions,
                selectedLocalRegion: selectedLocalRegion
            };
        }
        case LIBX_LOCAL_REGIONS_UNSET_LOCAL_REGION:
            return {
                ...localRegions,
                selectedLocalRegion: null
            };

        default:
            return localRegions;
    }
}
